import React from 'react';

import PropTypes from 'prop-types';

import { StylableComponent, stylePropType } from '@adsk/alloy-react-theme';

import Modal from './components/Modal';
import { containerStyle } from './helpers/styles';
import { Offering, offeringPropType } from './helpers/types';

type SubscriptionsModalViewProps = StylableComponent<HTMLDivElement> & {
  onCloseModal: () => void;
  subscriptions: Offering[];
  error: boolean;
  isLoading: boolean;
  refetch: () => void;
};
const SubscriptionsModalView = React.forwardRef<
  HTMLDivElement,
  SubscriptionsModalViewProps
>(
  (
    {
      className,
      onCloseModal,
      isLoading,
      error,
      style,
      subscriptions,
      refetch,
      ...props
    },
    ref,
  ) => {
    return (
      <div
        className={className}
        css={[containerStyle, style]}
        ref={ref}
        data-testid="SubscriptionsModalView"
        {...props}
      >
        <Modal
          isLoading={isLoading}
          onClose={onCloseModal}
          error={error}
          subscriptions={subscriptions}
          onClickTryAgain={refetch}
        />
      </div>
    );
  },
);

SubscriptionsModalView.displayName = 'SubscriptionsModalView';

SubscriptionsModalView.propTypes = {
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Closes modal*/
  onCloseModal: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  /** Styles applied to the root element */
  style: stylePropType,
  /**  User subscriptions and products*/
  subscriptions: PropTypes.arrayOf(offeringPropType.isRequired).isRequired,
  isLoading: PropTypes.bool.isRequired,
  refetch: PropTypes.func.isRequired,
};
export default SubscriptionsModalView;
